<button *ngIf="!isReporte" 
    bc-button 
    class="btn-reporte-vfiscal"
    sizeButton="small" 
    typeButton="secondary"
    (click)="reporte()">
    Validacion Fiscal
    <em class="bc-icon" aria-hidden="true" aria-label="prueba">download</em>
</button>
<div *ngIf="isReporte">
    <bc-loader speedLoader='0.5' sizeLoader='xs'>Reporte</bc-loader>
    <span>Generando...</span>
</div>